import React, { useState, useEffect } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import store from 'stores/CustomerDetailsStore';
import { AuthorizationWrapper } from 'components/wrappers/AuthorizationWrapper';
import LayoutWithSidebar from 'components/v2/LayoutWithSidebar';
import ShipperSettings from './ShipperSettings';
import EDISettings from './edi-settings';
import MarketAPIUtils from '../../../../utils/MarketAPIUtils';
import { getCustomerV2 } from '../../../../utils/CustomersAPIUtils';
import CustomersActionCreators from '../../../../actions/CustomersActionCreators';

export default function IntegrationSettings() {
  const params = useParams();
  const userId = params.id;
  const { t } = useTranslation();
  const [user, setUser] = useState();
  const [markets, setMarkets] = useState([]);

  useEffect(() => {
    store.addChangeListener(fetchUser);

    return () => {
      store.removeChangeListener(fetchUser);
    };
  }, []);

  async function fetchUser() {
    const user = await getCustomerV2(userId);
    setUser(user);
  }

  async function fetchMarkets() {
    try {
      const res = await MarketAPIUtils.getMarketsV2();
      setMarkets(res);
    } catch (e) {
      console.log('error getting markets', e.message);
    }
  }

  useEffect(() => {
    fetchMarkets();
    fetchUser();
  }, []);

  const renderSidebar = () => {
    return <ShipperSettings userId={userId} activePage="integrations" />;
  };

  const breadcrumbs = {
    pages: [
      {
        name: user?.company_name || t('SHIPPER'),
        href: `/users/${userId}`,
        current: false,
      },
      {
        name: t('INTEGRATION', { count: 2 }),
        href: `/users/${userId}/settings/integrations`,
        current: true,
      },
    ],
  };

  return (
    <LayoutWithSidebar
      sidebar={renderSidebar}
      breadcrumbs={breadcrumbs}
      className="py-4"
    >
      {user && (
        <AuthorizationWrapper excludedRegions={[]}>
          <EDISettings
            shipper={user}
            markets={markets}
            onCustomerPreferencesChange={CustomersActionCreators.updateShipper}
          />
        </AuthorizationWrapper>
      )}
    </LayoutWithSidebar>
  );
}
